<template>
    <div class="search-result-item ul-wide-border-panel mb-3">
        <div class="d-flex pt-2 pb-2 item-info-div">
            <div class="flex-grow-0 d-flex flex-column align-items-center justify-content-center pl-2 pr-2">
                <img class="part-image" v-bind:src="partImageSrc(searchItem.partImageURL)">
                <a class="part-image-credit" target="_blank" rel="nofollow" v-bind:href="searchItem.partImageCreditURL">{{searchItem.partImageCreditName}}</a>
            </div>
            <div class="flex-grow-1 d-flex flex-row flex-wrap search-result-content">
                <div class="d-flex flex-grow-1 flex-column align-items-center justify-content-center search-result-item-mfr-heading">
                    <div class="text-center">{{searchItem.mfrName}}</div>
                    <router-link v-if="searchItem.partUniqueId != null && searchItem.externalApiId != null" :to="`/${$store.state.instance}/part/p/${searchItem.partUniqueId}/e/${searchItem.externalApiId}`">{{searchItem.partNumber}}</router-link>
                    <router-link v-if="searchItem.partUniqueId != null && searchItem.externalApiId == null" :to="`/${$store.state.instance}/part/p/${searchItem.partUniqueId}`">{{searchItem.partNumber}}</router-link>
                    <router-link v-if="searchItem.partUniqueId == null && searchItem.externalApiId != null" :to="`/${$store.state.instance}/part/e/${searchItem.externalApiId}`">{{searchItem.partNumber}}</router-link>
                </div>
                <div class="d-flex flex-grow-1 search-result-item-description small m-2" v-bind:class="{'react-hidden' : searchItem.description === null }">
                    <div class="text-center">
                        {{searchItem.description}}
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-center pl-2 pr-2 search-result-item-border ">
                <div>Models Available</div>
                <div class="d-flex model-availability-listing">
                    <div v-bind:class="[searchItem.symbolAvailable ? 'model-availability-symbol-active' : 'model-availability-symbol-inactive']"></div>
                    <div v-bind:class="[searchItem.footprintAvailable ? 'model-availability-footprint-active' : 'model-availability-footprint-inactive']"></div>
                    <div v-bind:class="[searchItem.threeDAvailable ? 'model-availability-threed-active' : 'model-availability-threed-inactive']"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SearchResultsItem',
        props: {
            searchItem: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        methods: {
            partImageSrc(imgSrc) {
                if (imgSrc != undefined && imgSrc != null && imgSrc != '')
                    return imgSrc;
                return require('../../assets/images/placeholders/Image-Unavailable.png');
            }
        },
    };
    // mutate on search item selection to hit the part number
</script>

<style scoped>
</style>